module.exports = __webpack_public_path__ + "img/cxTrends-10.26c5060a.png";